import { createApi } from '@reduxjs/toolkit/query/react';

import {
  CreateInvoiceBody,
  CreateInvoiceResponse,
  InvoiceStatusResponse,
} from '@app/store/slices/payment/paymentTypes';
import { ApiResponse } from '@app/store/utils/common';
import { baseQueryWithReauth } from '@app/store/utils/baseQueryWithReauth';

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    createInvoice: builder.mutation<ApiResponse<CreateInvoiceResponse>, CreateInvoiceBody>({
      query: (body) => ({
        url: '/payment/invoices',
        method: 'POST',
        body,
      }),
    }),

    getInvoiceStatus: builder.query<ApiResponse<InvoiceStatusResponse>, string>({
      query: (invoiceId) => `/payment/invoices/${invoiceId}`,
    }),
  }),
});

export const { useCreateInvoiceMutation, useLazyGetInvoiceStatusQuery } = paymentApi;
